import { buildSerializer, buildDeserializer } from "lib/serializerUtils";

const serializeMap = {};

export const serializeSale = buildSerializer(serializeMap, "sale");
export const deserializeSale = buildDeserializer(serializeMap, "sale");
